import createIsPristine from './selectors/isPristine';
import plain from './structure/plain';
export default createIsPristine(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/isPristine.js
// module id = 5vQa
// module chunks = 1